module.exports = __webpack_public_path__ + "img/tappy.8207ca34.svg";